export class ForeignEntry {
    constructor(value, strValue) {
        this.value = value !== undefined ? value : -1;
        this.strValue = strValue ? strValue : '';
    }
}
